import { MantineComponentStaticProperties } from '@mantine/core'
import { useTranslation } from 'react-i18next'

/**
 * @t string - language token
 * @ns string - optional namespace of locales catalogue
 * @td {key: string} - data replacement for substitude
 */
export type CheckTProps = {
  t?: string
  ns?: 'translation' | string
  tdata?: { [key: string]: any }
}

export const checkText = (
  props: MantineComponentStaticProperties<any> & CheckTProps
) => {
  const { t: tf } = useTranslation(props.ns)
  if (typeof props.children !== 'string' || !props.t) {
    return props.children
  }
  return tf(props.t, { defaultValue: props.children, ...(props.tdata || {}) })
}
